/**
 * Created by lu on 2018/5/3.
 */
var nb = require('../../nb');
var confirmModel = require('../../model/modal/Confirm');
nb.model.confirm = confirmModel;
var languageKey;
var cnSidebar = {
    console:'控制台',
    cart:'购物车',
    inquiryText:'产品列表',
    orderManagement:'订单管理',
    invoiceInformation:'发票管理',
    issueInvoice:'开具发票',
    invoiceHistory:'发票历史',
    invoiceManagement:'发票信息',
    userCenter:'用户中心',
    companyInfo:'企业信息',
    accountInfo:'账户信息',
    address:'地址管理',
    jurisdiction:'员工管理',
    paymentDaysInfo:'账期信息'

};
var enSidebar = {
    console:'Console',
    cart:'Cart',
    inquiryText:'Inquiry',
    orderManagement:'Order',
    invoiceInformation:'Invoice', //Invoice
    issueInvoice:'Issue Invoice',
    invoiceHistory:'Invoice List',
    invoiceManagement:'Base Info',//Invoice Management
    userCenter:'User Center',
    companyInfo:'Enterprise',
    accountInfo:'Account',
    address:'Address',
    jurisdiction:'Employee',
    paymentDaysInfo:'Payment'

};
module.exports = nb.define({
    parent: require('../../Model'),
    mapping: {
        header: require('./Header'),  //
        sidebar: nb.Model,
        notice: require('../notice/Notice')
    },
    method: {
        init: function () {
            var self = this;
            var sidebar = this.get('sidebar');
            //监听点击激活侧边栏文字
            this.onChange('activeLi',function (inEvent,inKey) {
                sidebar.set('activeLi',inKey);
            },this);
            this.set('header', {
                style: 'default'  //服务页header     console
            });

            nb.model.onChange(nb.opts.clientReady, function () {
                this.setSectionHeight();
            }, this);

            nb.model.onChange('changeLanguageReady', function (inEvent, inData) {
                languageKey = inData;
                if(inData == 'cn'){
                    this.setOpts({
                        sidebar:cnSidebar
                    })
                }else{
                    this.setOpts({
                        sidebar:enSidebar
                    })
                }
            }, this);

            $(window).resize(function () {
                self.setSectionHeight();
            });
            nb.model.onChange('dataReady', function (inEvent, inState) {
                this.set('dataReady', inState);//
            }, this);

        },
        _isPageLogin: function () {
            return true;
        },
        setSectionHeight: function () {
            var screenH = document.body.clientHeight;
            this.set('sectionMinHeight', screenH - 160 + 'px');
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/control/Model.js
// module id = 21
// module chunks = 0 1 2 3 4 7 8 9 10 12 13 14 15 16 18 19 20 21 22 23 25 26 27 28 29 30 34